import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../KeyComponents';

function DateSelector({
  month,
  year,
  setMonth,
  setYear,
  minMonth,
  minYear,
  maxMonth,
  maxYear,
}) {
  const canGoPrev = (minMonth && minYear) ? year > minYear || (year === minYear && month > minMonth) : true;
  const canGoNext = (maxMonth && maxYear) ? year < maxYear || (year === maxYear && month < maxMonth) : true;

  const handleChange = (direction) => {
    if (direction === 'prev' && canGoPrev) {
      if (month === 0) {
        setMonth(11);
        setYear(year - 1);
      } else {
        setMonth(month - 1);
      }
    } else if (direction === 'next' && canGoNext) {
      if (month === 11) {
        setMonth(0);
        setYear(year + 1);
      } else {
        setMonth(month + 1);
      }
    }
  };

  return (
    <div className="date-selector">
      <Icon icon="arrow-left-s" onClick={() => handleChange('prev')} disabled={!canGoPrev} />
      <div className="date-display">
        {new Date(year, month).toLocaleString('default', { month: 'long' })} {year}
      </div>
      <Icon icon="arrow-right-s" onClick={() => handleChange('next')} disabled={!canGoNext} />
    </div>
  );
}

DateSelector.propTypes = {
  month: PropTypes.number,
  year: PropTypes.number.isRequired,
  setMonth: PropTypes.func.isRequired,
  setYear: PropTypes.func.isRequired,
  minMonth: PropTypes.number,
  minYear: PropTypes.number,
  maxMonth: PropTypes.number,
  maxYear: PropTypes.number,
};

DateSelector.defaultProps = {
  month: new Date().getMonth(),
  minMonth: null,
  minYear: null,
  maxMonth: null,
  maxYear: null,
};

export default DateSelector;
